import React from "react";
import { Container } from "react-bootstrap";

function ListSites({ siteList }) {
  return (
    <>
      <Container>
        <ul className="list-group">
          {siteList.map(({ routePath, title }, index) => (
            <li className="list-group-item ">
              <h1 className="text-primary">
                <a
                  href={routePath}
                  class="list-group-item list-group-item-action"
                >
                  {title}
                </a>
              </h1>
            </li>
          ))}
        </ul>
      </Container>
    </>
  );
}

export default ListSites;
